function CoefficientTable() {
  return (
    <figure className='my-8'>
      <figcaption className='mb-2 text-center font-medium'>
        جدول شماره 2: ضرایب گروه‌های درسی آزمون پذیرش دستیار برای رشته‌های مختلف تخصصی
      </figcaption>
      <table className='w-full table-auto border-collapse border border-zinc-400 text-sm'>
        <thead className='bg-zinc-300'>
          <tr className='border border-zinc-400'>
            <th
              rowSpan={2}
              className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold xs:p-3'
            >
              زیر‌گروه
            </th>
            <th
              rowSpan={2}
              className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold xs:p-3'
            >
              رشته‌ها
            </th>
            <th
              colSpan={6}
              className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold xs:p-3'
            >
              گروه‌های درسی
            </th>
          </tr>
          <tr className='border border-zinc-400'>
            <th className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-semibold xs:p-3'>
              یک
            </th>
            <th className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-semibold xs:p-3'>
              دو
            </th>
            <th className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-semibold xs:p-3'>
              سه
            </th>
            <th className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-semibold xs:p-3'>
              چهار
            </th>
            <th className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-semibold xs:p-3'>
              پنج
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className='border odd:bg-white even:bg-zinc-200'>
            <td className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-medium text-zinc-800 xs:p-3'>
              یک
            </td>
            <td className='border border-zinc-400 p-1 text-center text-xs leading-relaxed xs:p-3 sm:text-sm'>
              داخلی - قلب - پوست - طب کار - پزشکی قانونی - سالمندان - پزشکی خانواده - پاتولوژی - طب
              فیزیکی
            </td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>4</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
          </tr>

          <tr className='border odd:bg-white even:bg-zinc-200'>
            <td className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-medium text-zinc-800 xs:p-3'>
              دو
            </td>
            <td className='border border-zinc-400 p-1 text-center text-xs leading-relaxed xs:p-3 sm:text-sm'>
              جراحی - زنان - اورولوژی - ENT - چشم - جراحی قلب - جراحی توراکس
            </td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>4</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
          </tr>

          <tr className='border odd:bg-white even:bg-zinc-200'>
            <td className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-medium text-zinc-800 xs:p-3'>
              سه
            </td>
            <td className='border border-zinc-400 p-1 text-center text-xs leading-relaxed xs:p-3 sm:text-sm'>
              اطفال - عفونی - پزشکی اجتماعی
            </td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>3</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>4</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
          </tr>

          <tr className='border odd:bg-white even:bg-zinc-200'>
            <td className='whitespace-nowrap border border-zinc-400 p-1 text-center text-sm font-medium text-zinc-800 xs:p-3'>
              چهار
            </td>
            <td className='border border-zinc-400 p-1 text-center text-xs leading-relaxed xs:p-3 sm:text-sm'>
              طب اورژانس - بیهوشی - نوروسرجری - ارتوپدی - پزشکی ورزشی - رادیو انکولوژی - طب هسته‌ای،
              رادیولوژی - هوا و فضا
            </td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>3</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
          </tr>

          <tr className='border odd:bg-white even:bg-zinc-200'>
            <td className='whitespace-nowrap border border-zinc-400 p-1 text-center font-semibold text-zinc-800 xs:p-3'>
              پنج
            </td>
            <td className='border border-zinc-400 p-1 text-center text-xs leading-relaxed xs:p-3 sm:text-sm'>
              روان‌پزشکی - نورولوژی
            </td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>3</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>2</td>
            <td className='border border-zinc-400 p-1 text-center font-bold xs:p-3'>3</td>
          </tr>
        </tbody>
      </table>
    </figure>
  );
}

export default CoefficientTable;
